import logo from '../assets/imgs/logo-indemniza.webp';
import complaintsBook from '../assets/imgs/libro-reclamaciones-legal.jpg';
import { CONTACT, SOCIALS } from '../data/site';
import { Icon } from './Icon';

type Props = { compact?: boolean };

function SocialLinks() {
  return (
    <div className="footer-socials" aria-label="Redes sociales">
      <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Icon name="instagram" size={16} /></a>
      <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Icon name="facebook" size={15} /></a>
      <a href={`https://wa.me/${CONTACT.phoneInternational}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><Icon name="whatsapp" size={15} /></a>
      <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"><Icon name="tiktok" size={15} /></a>
    </div>
  );
}

function ContactBlock() {
  return (
    <section className="footer-contact" aria-labelledby="footer-contact-title">
      <h2 id="footer-contact-title">Contacto</h2>
      <address>
        <p><Icon name="mapPin" size={16} /> <span>{CONTACT.address}</span></p>
        <a href={`tel:+${CONTACT.phoneInternational}`}><Icon name="phone" size={16} /> <span>{CONTACT.phoneDisplay}</span></a>
        <a href={`mailto:${CONTACT.email}`}><Icon name="mail" size={16} /> <span>{CONTACT.email}</span></a>
      </address>
    </section>
  );
}

function LegalRow() {
  return (
    <div className="footer-legal">
      <p>© {new Date().getFullYear()} Corporación Indemniza. Todos los derechos reservados.</p>
      <nav aria-label="Enlaces legales">
        <a href="/politica-de-privacidad">Política de privacidad</a>
        <a href="/terminos">Términos y condiciones</a>
        <a href="/libro-de-reclamaciones" target="_blank" rel="noopener noreferrer">Libro de Reclamaciones</a>
      </nav>
    </div>
  );
}

export function Footer({ compact = false }: Props) {
  return (
    <footer className={`site-footer${compact ? ' site-footer--compact' : ''}`}>
      <div className="site-container footer-top">
        <section className="footer-brand" aria-label="Corporación Indemniza">
          {!compact ? (
            <img
              src={logo}
              alt="Corporación Indemniza"
              loading="lazy"
            />
          ) : null}

          <p>
            Especialistas en reparación y compensación legal de daños.
            Acompañamos cada caso con estrategia legal, transparencia y
            respaldo técnico.
          </p>

          <SocialLinks />
        </section>

        <ContactBlock />

        <section
          className="footer-complaints"
          aria-label="Libro de Reclamaciones"
        >
          <a
            href="/libro-de-reclamaciones"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Abrir el Libro de Reclamaciones de Corporación Indemniza en una nueva pestaña"
          >
            <img
              src={complaintsBook}
              alt="Libro de Reclamaciones de Corporación Indemniza"
              loading="lazy"
            />
          </a>
        </section>
      </div>

      {!compact ? (
        <div className="site-container footer-map">
          <h2>Ubicación</h2>
          <iframe
            title="Ubicación de Corporación Indemniza"
            src={CONTACT.mapEmbedUrl}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      ) : null}

      <div className="site-container"><LegalRow /></div>
    </footer>
  );
}
